module.exports = __webpack_public_path__ + "media/img/ms-icon-310x310-60ac201f59fb2d63086ff267839bfda7.png";